import React from 'react';

export const GlobalSpinnerContext = React.createContext();

export const useGlobalSpinnerContext = () => React.useContext(GlobalSpinnerContext);
